module.exports = __webpack_public_path__ + "static/example-image-2-2ddd366e259e33332b73932cb1f99c02.jpg";